<div class="map-wrapper">
  <div class="header">
    <span>Геолокация</span>
    <span class="close" matDialogClose>✕</span>
  </div>
  <div #map id="map" class="map"></div>
  <div class="buttons">
    <button class="btn btn-apply" (click)="save()">Сохранить</button>
    <button class="btn btn-cancel" (click)="close()">Отменить</button>
  </div>
</div>
